<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <font-awesome-icon :icon="['fas', 'code-branch']" />
        <span class="title">Loose ends</span>
      </Header>
      <v-form>
        <v-row class="row-height rowbox">
          <v-col class="col-3">
            <b>Manually merging</b>
            <v-subheader><b>Maximum time span</b></v-subheader>
            <br /><br />
            <v-subheader><b>Maximum distance</b></v-subheader>
          </v-col>
          <v-col class="col-1">
            <v-text-field
              v-model="field.field_loosem_time"
              type="number"
              background-color="#42B98340"
              @change="
                field_update('field_loosem_time', field.field_loosem_time)
              "
              min="0"
              outlined
            >
            </v-text-field>
            <v-text-field
              v-model="field.field_loosem_distance"
              type="number"
              background-color="#42B98340"
              @change="
                field_update(
                  'field_loosem_distance',
                  field.field_loosem_distance
                )
              "
              min="0"
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col class="col-2">
            <div class="col-middle">
              <v-subheader
                >Number of objects to test with current settings</v-subheader
              >
            </div>
          </v-col>
          <v-col class="col-1 col-middle">
            <v-text-field
              v-model="field.field_loosem_ntest"
              type="number"
              background-color="#42B98340"
              @change="
                field_update('field_loosem_ntest', field.field_loosem_ntest)
              "
              min="0"
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col class="col-2 col-middle">
            <v-subheader>
              <router-link :to="{ name: 'settings_zones_loose_endsm' }"
                ><font-awesome-icon :icon="['fas', 'balance-scale']" /><span
                  class="title"
                  >Do test</span
                ></router-link
              >
            </v-subheader>
          </v-col>
          <v-col class="col-2 col-middle ">
            <v-subheader>Don't show to operator if above maximum </v-subheader>
          </v-col>
          <v-col class="col-1 col-middle">
            <v-switch
              v-model="field.field_loosem_autodelete"
              true-value="1"
              false-value="0"
              color="#00ff00"
              @change="
                field_update(
                  'field_loosem_autodelete',
                  field.field_loosem_autodelete
                )
              "
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row class="row-height rowbox">
          <v-col class="col-3">
            <b>Automatically merging</b>

            <v-subheader><b>Maximum time span (automatically)</b></v-subheader>
            <br /><br />
            <v-subheader><b>Maximum distance (automatically)</b></v-subheader>
          </v-col>
          <v-col class="col-1">
            <v-text-field
              v-model="field.field_loosea_time"
              type="number"
              background-color="#42B98340"
              @change="
                field_update('field_loosea_time', field.field_loosea_time)
              "
              min="0"
              outlined
            >
            </v-text-field>
            <v-text-field
              v-model="field.field_loosea_distance"
              type="number"
              background-color="#42B98340"
              @change="
                field_update(
                  'field_loosea_distance',
                  field.field_loosea_distance
                )
              "
              min="0"
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col class="col-2">
            <div class="col-middle">
              <v-subheader
                >Number of objects to test with current settings</v-subheader
              >
            </div>
          </v-col>
          <v-col class="col-1 col-middle">
            <v-text-field
              v-model="field.field_loosea_ntest"
              type="number"
              background-color="#42B98340"
              @change="
                field_update('field_loosea_ntest', field.field_loosea_ntest)
              "
              min="0"
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col class="col-2 col-middle">
            <v-subheader>
              <router-link :to="{ name: 'settings_zones_loose_endsa' }"
                ><font-awesome-icon :icon="['fas', 'balance-scale']" /><span
                  class="title"
                  >Do test</span
                ></router-link
              >
            </v-subheader>
          </v-col>
          <v-col class="col-2 col-middle ">
            <v-subheader>Merge automatically if below maximum </v-subheader>
          </v-col>
          <v-col class="col-1 col-middle">
            <v-switch
              v-model="field.field_loosea_autodelete"
              color="#00ff00"
              true-value="1"
              false-value="0"
              hide-details
              @change="
                field_update(
                  'field_loosea_autodelete',
                  field.field_loosea_autodelete
                )
              "
            ></v-switch>
          </v-col>
        </v-row>

        <v-row class="row-height rowbox">
          <v-col class="col-12">
            <v-subheader
              ><b
                >What to do with remaining loose ends after being judged 'not
                connected'?
              </b></v-subheader
            >
            <input
              type="radio"
              id="twee"
              v-model="field.field_loose_ends_remaining"
              value="1"
              @change="
                field_update(
                  'field_loose_ends_remaining',
                  field.field_loose_ends_remaining
                )
              "
            />
            <label for="twee">Mark as disabled</label><br />
            <input
              type="radio"
              id="een"
              v-model="field.field_loose_ends_remaining"
              @change="
                field_update(
                  'field_loose_ends_remaining',
                  field.field_loose_ends_remaining
                )
              "
              value="2"
            />
            <label for="een">Mark as enabled</label>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
export default {
  components: {
    Header
  },
  data: () => {
    return {
      routes: {},
      switch1: true,
      nrecords: {},
      min: 0,
      field: {},
      del_conf: false,
      max: 50,
      slider: 40,
      range: [10, 20]
    };
  },
  mounted() {
    this.ApiGet();
  },
  methods: {
    ApiGet() {
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "settings_loose_ends"
      })
        .then(response => {
          this.field = response.data.fields;
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    },
    field_update(field, value) {
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "update_fields",
        field,
        value
      });
    },
    btn_reset(e) {
      e.preventDefault();
      let currentObj = this;
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "settings_loose_ends_reset"
      })
        .then(function(response) {
          currentObj.output = response.data;
        })
        .catch(e => {
          this.errors.push(e);
        });
    }
  }
};
</script>
<style scoped>
button {
  align-items: center;
  justify-content: center;
  width: 8em;
  height: 1em;
  margin: 0.3em;
  border-radius: 5px;
  background: linear-gradient(to right, #16c0b0, #84cf6a);
  font-size: 1em;
  color: white;
  border: none;
  outline: none;
}
.col-middle {
  vertical-align: bottom;
  margin-top: 50px;
}
</style>
